class TranslationItem {
  constructor(language = '', name = '', shortName = '', description = '') {
    this.language = language;
    this.name = name;
    this.shortName = shortName;
    this.description = description;
  }
}

export default TranslationItem;
